import React from "react";
import Tooltip from "../Tooltip";

const PageHeader = ({ title, subtitle, actions, tooltipCode, level = "page" }) => {
  return (
    <div className={`page-title-row${level === "section" ? " page-title-row--section" : ""}`}>
      <div className="page-title-row__copy">
        <h1>
          {title}
          {tooltipCode ? <Tooltip code={tooltipCode} /> : null}
        </h1>
        {subtitle ? <p>{subtitle}</p> : null}
      </div>
      {actions ? <div className="page-title-row__actions">{actions}</div> : null}
    </div>
  );
};

export default PageHeader;
